module.exports = __webpack_public_path__ + "a768e7de/img/dollar-icon.35c9d638.svg";